export default __webpack_public_path__ + "static/media/pic_vox.c428b613.png";